module.exports = __webpack_public_path__ + "static/media/bg-login.37c3f738.png";